import { ChangePasswordFormData } from '../../../../entities/@forms/ChangePasswordForm/ChangePasswordForm';
import {
    FormErrors,
    FormValidation,
    validateForm,
    validateRequiredString,
} from '../../../../entities/@forms/FormValidation/FormValidationService';
import trans from '../../../../helpers/trans';

export type ChangePasswordFormErrors = FormErrors<ChangePasswordFormData>;

export const validateChangePasswordFormData = (formData: ChangePasswordFormData): FormValidation<ChangePasswordFormErrors> => {
    const { currentPassword, newPassword = '', confirmNewPassword = '' } = formData;

    const errors: ChangePasswordFormErrors = {
        currentPassword: validateRequiredString('currentPassword', currentPassword),
        newPassword: validateRequiredString('newPassword', newPassword),
        confirmNewPassword: validateRequiredString('confirmNewPassword', confirmNewPassword),
    };

    const passwordsAreNotEqual = newPassword && newPassword !== confirmNewPassword;

    if (passwordsAreNotEqual) {
        errors.confirmNewPassword = trans('errors.passwordsAreNotEqual');
    }

    return validateForm<ChangePasswordFormErrors>(errors);
};
